import { useHotkeys } from 'react-hotkeys-hook'

interface LabelingHotkeyHandlers {
  /** Labels in order; number keys 1-9 map to the first nine. */
  sessionLabels: string[]
  /** Assign a label to the current selection. */
  assignLabel: (label: string) => void
  /** Invert the current (visible) selection. */
  invertVisible: () => void
  /** Move to the previous / next cluster. */
  prevCluster: () => void
  nextCluster: () => void
}

/**
 * Keyboard shortcuts for the labeling view:
 *   1-9  assign that label to the selection
 *   i    invert the selection
 *   [ ]  previous / next cluster
 * react-hotkeys-hook ignores key presses while a text input is focused, so
 * typing a new label name does not trigger these.
 */
export const useLabelingHotkeys = ({
  sessionLabels,
  assignLabel,
  invertVisible,
  prevCluster,
  nextCluster,
}: LabelingHotkeyHandlers): void => {
  useHotkeys(
    '1,2,3,4,5,6,7,8,9',
    (keyboardEvent) => {
      const index = Number(keyboardEvent.key) - 1
      const label = sessionLabels[index]
      if (label) assignLabel(label)
    },
    {},
    [sessionLabels, assignLabel]
  )
  useHotkeys('i', () => invertVisible(), {}, [invertVisible])
  useHotkeys('[', () => prevCluster(), {}, [prevCluster])
  useHotkeys(']', () => nextCluster(), {}, [nextCluster])
}

export default useLabelingHotkeys
